import { PageDS, Spacer, TabMenu, ToastContainerDS } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CardTransactionsTab } from "./cards/cardTransactionsTab";
import { BadgeTransactionsTab } from "./badges/badgeTransactionsTab";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { selectCompany } from "../homeSlice";
import "../../../i18n/i18n";
import { selectManagersList } from "../users/usersSlice";
import { supportPhonesByCompanyGroupUuid } from "../../../constants/support";
import { rulesListAsync, selectRulesListStatus } from "../rules/rulesSlice";
import { EmspCdrsTab } from "./emsp/emspCdrsTab";

export const Transactions = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useAppDispatch();

  const company = useAppSelector(selectCompany);
  const [selectedTab, setSelectedTab] = useState<string>(params.tab ?? "cards");
  const managers = useAppSelector(selectManagersList);
  const rulesListStatus = useAppSelector(selectRulesListStatus);

  const otherSupportPhones = useMemo(
    () =>
      managers && managers.length > 0 && managers[0].companyGroup
        ? supportPhonesByCompanyGroupUuid[managers[0].companyGroup]
        : undefined,
    [managers],
  );

  const tabs = useMemo(() => {
    return [
      {
        name: "cards",
        title: t("transactions.tab.cards"),
      },
      {
        name: "badges",
        title: t("transactions.tab.badges"),
      },
      {
        name: "emspCdrs",
        title: t("transactions.tab.emspCdrs"),
      },
    ];
  }, [t]);

  useEffect(() => {
    if (company && !company.canOrderBadges && selectedTab === "badges") {
      setSelectedTab("cards");
    }
  }, [company, selectedTab]);

  useEffect(() => {
    if (company && rulesListStatus === "idle") {
      void dispatch(rulesListAsync(company.uuid));
    }
  }, [company, dispatch, rulesListStatus]);

  useEffect(() => {
    if (selectedTab) {
      navigate(
        `/home/transactions/${selectedTab}${
          params.id !== undefined ? `/${params.id}` : ""
        }`,
      );
    }
  }, [navigate, params.id, selectedTab]);

  return (
    <PageDS
      title={t("transactions.title")}
      toaster={<ToastContainerDS />}
      topElement={
        <>
          <TabMenu
            tabs={tabs}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
          />
          <Spacer y={0.5} />
        </>
      }
      supportButton={{
        showMail: !otherSupportPhones,
        otherPhones: otherSupportPhones,
      }}
    >
      <CardTransactionsTab />
      <BadgeTransactionsTab />
      <EmspCdrsTab />
    </PageDS>
  );
};
